namespace SP.Data {
    export class PickProfile {


        static async getPickProfileInfo(profileId: string): Promise<PickProfileInfo> {
            var response = await SP.get<any>("/api/v1/info/pickProfileInfo/" + profileId);
            if (response.status == 200) return response.data as PickProfileInfo;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }

        static async getPickProfileInfos(customerId: string) {
            var response = await SP.get<any>("/api/v1/info/pickProfileInfos/" + customerId);
            if (response.status == 200) return response.data as PickSettingInfo[];
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }


    }
}